{
  "ACTIONS": {
    "CONFIRM": "Confirm",
    "CONTINUE": "Продължи",
    "SUBMIT": "Submit",
    "RETRY": "Опитай отново",
    "CANCEL": "Cancel",
    "EMPTY": "You have no orders",
    "LOADING_ORDERS": "Подготвяме сметката ви",
    "CLEAR_ALL": "Clear All",
    "AWESOME": "Awesome!",
    "VIEW_RECEIPT": "The Receipt",
    "ADD_CART": "Add to Cart",
    "UPDATE_CART": "Update Cart",
    "EDIT": "Edit",
    "SEARCH_PLACEHOLDER": "Search for food or restaurants"
  },
  "COMMON": {
    "CALORIES": "Cal. {{calories}}",
    "MISSING_SELECTIONS": "Some options are missing, please select before proceeding",
    "ITEM_UNAVAILABLE": "This item is currently not available",
    "SECTION_NOT_FOUND": "Този раздел вече не е наличен",
    "ITEM_NOT_FOUND": "Този артикул вече не е наличен",
    "PROMOTION_NOT_AVAILABLE": "Тази промоция вече не е налична",
    "REQUIRED": "Required",
    "COMBO": "Комбо",
    "INVALID_EMAIL": "Моля, въведете валиден имейл адрес",
    "INVALID_PHONE": "Моля, въведете валиден телефонен номер",
    "FEES": "Fees",
    "MIN_ORDER_ERROR": "Minimum order value of {{currency}} {{amount}} is required to place your order",
    "ADD_MIN_ORDER": "Add {{currency}} {{amount}} to place your order",
    "CONNECTION_ERROR": "Нещо се обърка при зареждането на тази маса. Моля, опитайте отново.",
    "TABLE_NOT_FOUND": "Не успяхме да намерим тази маса. Моля, сканирайте QR кода отново."
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Last Name",
    "ROOM_NUMBER": "Room Number",
    "SNACKBAR_TITLE": "Your bill is on the way",
    "PAY_BILL": "Pay bill"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "Общ брой хора на масата",
    "PAYING_FOR": "Общ брой хора, за които плащате",
    "REMAINING": "Оставаща сума",
    "CHEQUE": "Сметка",
    "AMOUNT_PAID": "Платена сума",
    "DISCOUNT": "Отстъпка",
    "PROMO": "Промо",
    "FEES": "Такси",
    "PAID_ITEMS": "Платени артикули",
    "SPLIT_BILL": "Раздели сметката",
    "EDIT_SPLIT": "Редактирай разделянето",
    "PAY_BILL": "Плати сметката",
    "SPLIT_TITLE": "Раздели сметката",
    "SPLIT_SUBTITLE": "Изберете как искате да разделите сметката",
    "SPLIT_EVENLY": "Раздели поравно",
    "CUSTOM_AMOUNT": "Персонализирана сума",
    "ADD_CUSTOM_AMOUNT": "Добави персонализирана сума",
    "CUSTOM_AMOUNT_PLACEHOLDER": "Въведете персонализирана сума",
    "PAY_FOR_ITEMS": "Платете за вашите артикули",
    "CONFIRM_SELECTION": "Потвърди избора",
    "SOMEONE_ELSE_PAYING": "Някой друг на вашата маса плаща в момента"
  },
  "COMBO": {
    "ADD_N": "Добави {{count}} {{section}}",
    "REMOVE_N": "Премахни {{count}} {{section}}",
    "CANNOT_PROCEED": "Моля, следвайте указанията по-горе, за да завършите комбото, преди да продължите",
    "COMPLETE": "Комбо „{{combo}}“ е готово!",
    "ON_ANOTHER_SECTION": "Това е част от вашето комбо „{{section}}“"
  },
  "CART": {
    "TITLE": "Cart",
    "RECOMMENDATION": "You may also like",
    "TOTAL": "Total",
    "VIEW": "View cart & Place order",
    "EMPTY": "Empty",
    "PLACE_ORDER": "Place order",
    "ADD_TO_BILL": "Добави към сметката",
    "PAY_NOW": "Плати сега",
    "OOPS": "Oops",
    "ADD_NEW_VARIANT": "Добави още един",
    "VARIANT_TITLE": "Променихте ли решението си?",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Are you sure you want to clear the cart?",
    "CLEAR": "Clear Cart",
    "ADD_NOTE": "ADD A NOTE",
    "NOTE_LABEL": "Note"
  },
  "PAYMENT": {
    "CONFIRMED": "Your order has been paid !",
    "ERROR": "An error occurred during payment, please try again",
    "APPLE_PAY_TAP_AGAIN": "Please tap Apple Pay again to continue",
    "TITLE": "Плащане",
    "PAY_CARD": "Checkout",
    "SUCCESSFUL": "Payment Was Successful",
    "SUMMARY": "Payment Summary",
    "PROGRESS": "Payment in progress..., please wait",
    "CANCEL": "Please do not refresh this page or click on the back button. If you wish to cancel, please press the cancel button on the payment machine."
  },
  "ORDER": {
    "TITLE": "My orders",
    "CONFIRMED": "Confirmed",
    "NOTES": "Order Notes",
    "TOTAL": "Total",
    "SUBTOTAL": "Subtotal",
    "ORDER": "Order",
    "PAID": "Paid",
    "PLACED": "Your Order Has Been Placed",
    "UNPAID": "Поръчката ви не е платена",
    "CANCELLED": "Поръчката ви е отменена",
    "VOID": "Поръчката ви е анулирана",
    "UPDATED": "Поръчката ви е актуализирана",
    "ORDERS": "Orders",
    "PREVIOUS": "Previous Orders",
    "REJECTED": "Oops! One or more items or modifiers are currently unavailable and have been removed from your cart."
  },
  "WAITER": {
    "SNACKBAR_TITLE": "We'll be with you shortly",
    "HELP": "How can we help?",
    "ADDITIONAL_COMMENTS": "Comments"
  },
  "MENU": {
    "SKIP": "Пропусни",
    "MENU": "Menu",
    "SEARCH": "Search",
    "NO_SEARCH_RESULTS": "No items match your search",
    "SEARCH_OTHER_SECTIONS": "We found matches in other sections",
    "NO_FILTER_RESULTS": "No items match your filters",
    "CLEAR_FILTERS": "Clear filters",
    "NO_SECTIONS": "No sections available",
    "STAFF": "Call staff",
    "FILTERS": "Dietery Filters"
  },
  "SETTINGS": {
    "TITLE": "Settings",
    "LANGUAGE": "Language",
    "SELECT_LANGUAGE": "Изберете език",
    "CURRENCY": "Currency"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "Charge to my room"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "Please rescan the QR to continue your session",
    "SESSION_EXPIRED": "Your session has expired"
  },
  "PICKUP": {
    "TITLE": "Your Details"
  },
  "VOUCHER": {
    "ADD": "Add a Voucher",
    "PLACEHOLDER": "Въведете вашия ваучер",
    "VOUCHER": "Voucher",
    "DISCOUNTED_AMOUNT": "Total After Discount",
    "CURRENT_BALANCE": "Balance",
    "REMAINING_BALANCE": "Balance After Purchase",
    "AMOUNT_DUE": "Amount Due"
  },
  "TIP": {
    "TIP": "Бакшиш",
    "ADD": "Добави бакшиш",
    "PLACEHOLDER": "Въведете сума за бакшиш"
  },
  "LANDING": {
    "CALL_WAITER": "Повикай сервитьор",
    "VIEW_BILL": "Виж сметката - ",
    "LOADING_BILL": "Зареждане на сметката"
  },
  "LOADER": {
    "Heading": "Обработваме плащането ви...",
    "Subheading": "Моля, не затваряйте тази страница. Потвърждаваме плащането ви и ще ви пренасочим автоматично.",
    "Hint": "Обикновено това отнема няколко секунди."
  },
  "NoVoucher": "Ваучерът не е наличен",
  "VoucherDisabled": "Този ваучер е деактивиран",
  "VoucherExpired": "Този ваучер е изтекъл",
  "VoucherAlreadyUsed": "Този ваучер вече е използван",
  "VoucherZeroBalance": "Този ваучер има баланс 0",
  "VoucherUserLimitReached": "Вече сте използвали този ваучер",
  "VoucherFirstOrderOnly": "Този ваучер е само за първата ви поръчка",
  "VoucherNotApplicable": "Този ваучер не се отнася за артикулите в поръчката ви"
}
